export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14626.85854686.jpg";